import { useTranslation } from 'react-i18next';

import ShopButton from '../Buttons/ShopButton';
import Terms from '../Buttons/Terms';

import styles from './Welcome.module.scss';

const Welcome = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.contentContainer}>
      <div className={styles.content}>
        <h1 className={styles.title}>{t('loyalty:balance:companyPoints')}</h1>
        <p className={styles.description}>
          {t('loyalty:balance:wayToShopping')}
        </p>
      </div>

      <div className={styles.buttonWrapper}>
        <ShopButton />
        <Terms />
      </div>
    </div>
  );
};

export default Welcome;
